import { getFinancialErrorCode } from '#components/product-finance/errors';

export function getManagementErrorMessage(
  error: unknown,
  t: (value: string) => string,
): string {
  switch (getFinancialErrorCode(error)) {
    case 'invalid-cycle':
      return t('Select an available budget cycle.');
    case 'currency-mismatch':
      return t('Use the configured financial currency.');
    case 'source-not-found':
      return t('This financial source no longer exists.');
    case 'invalid-input':
      return t('Check the dates and positive values.');
    default:
      return t('We could not save these financial settings.');
  }
}
